import { render, staticRenderFns } from "./OnboardingFeatureBasedOptions.vue?vue&type=template&id=e9093a8c&scoped=true&"
import script from "./OnboardingFeatureBasedOptions.vue?vue&type=script&lang=js&"
export * from "./OnboardingFeatureBasedOptions.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingFeatureBasedOptions.vue?vue&type=style&index=0&id=e9093a8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9093a8c",
  null
  
)

export default component.exports